export class StripePaymentModel {
    public "productId": string;
    public "token": string;
    public "cardId": string;
    public "priceRecurringTypeId": number;
    public "paymentDescription": string = "";
}